import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { NaturalPersonOnboarding } from "Components/Onboarding/NaturalPerson/NaturalPersonOnboarding";
import { useIsUserInMooneLite } from "Hooks/useIsUserInMooneLite";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { Version } from "Infrastructure/Api/Api";
import { Navigate } from "Navigation/Navigate";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

export const CompleteCustomerOnboardingPage = () => {
  const currentUser = useLoggedInUser();
  const { isLiteBecauseOfBank } = useIsUserInMooneLite();
  const { t } = useResource();

  // A user who already finished registration (FullMoone) has nothing to do here. Gate on version,
  // not UserStatus: a migrated merchant acting in their Customer context inherits the merchant's
  // Active status but is still MooneLite and must be allowed to complete Customer registration.
  if (currentUser?.version === Version.FullMoone) {
    return <Navigate to={appUrl("dashboard")} />;
  }

  // The wizard is done; re-submitting it cannot lift the tier — only the bank connect can. Right
  // after the final step the store is still stale; the redirect fires once the refreshed user info
  // (status Active) arrives.
  if (isLiteBecauseOfBank) {
    return <Navigate to={appUrl("banking-auth")} />;
  }

  return (
    <AuthenticatedLayout
      title={t(Resources.Onboarding.Title)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("dashboard"),
      }}
    >
      <NaturalPersonOnboarding />
    </AuthenticatedLayout>
  );
};
